import type { RegistrationSchemaType } from './stepsMap';

import { useQuery } from 'react-query';

import ApiClient from '$/ApiClient';

interface IUseRegistrationFeedback {
  state: RegistrationSchemaType;
}

export const useRegistrationFeedback = ({
  state,
}: IUseRegistrationFeedback) => {
  const majorQuery = useQuery(
    'automatedFeedback',
    async () =>
      ApiClient.automatedFeedback({
        data: {
          majorId: Number(state?.major?.[0]?.id),
          expectedDegreeId: Number(state?.expectedDegree?.[0]?.id),
          variantId: Number(state?.variant?.[0]?.id),
          fieldId: Number(state?.field?.[0]?.id),
        },
      }),
    {
      refetchOnMount: true,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
    }
  );
  return majorQuery.data;
};
